export const SET_USER_STATS = 'RANKING/SET_USER_STATS'
export const SET_RANKING = 'RANKING/SET_RANKING'
